export default [
  {
    header: 'GS ENCUESTA',
  },
  {
    title: 'Dashboards',
    icon: 'HomeIcon',
    // tag: '1',
    tagVariant: 'light-warning',
    resource: 'app-dashboard-indicadores',
    children: [
      /* {
        title: 'Visor Mapa',
        route: 'app-dashboard-visor',
        resource: 'app-dashboard-visor',
      }, */
      {
        title: 'Tablero Indicadores',
        route: 'app-dashboard-indicadores',
        resource: 'app-dashboard-indicadores',
      },
    ],
  },
  {
    title: 'Reporte',
    icon: 'HomeIcon',
    // tag: '1',
    tagVariant: 'light-warning',
    resource: 'app-reporte-encuestador',
    children: [
      {
        title: 'Reporte',
        route: 'app-reporte-encuestador',
        resource: 'app-reporte-encuestador',
      },
    ],
  },
  {
    title: 'Encuesta',
    icon: 'TrelloIcon',
    // tag: '2',
    tagVariant: 'light-warning',
    resource: 'app-encuesta-encuesta',
    children: [
      {
        title: 'Encuesta',
        route: 'app-encuesta-encuesta',
        resource: 'app-encuesta-encuesta',
      },
      {
        title: 'Encuestado',
        resource: 'app-encuesta-encuestado', // SI NO SE AGREGA NO SE MUESTRA EN EL SISTEMA
        route: 'app-encuesta-encuestado',
      },
      {
        title: 'Encuestador',
        route: 'app-encuesta-encuestador',
        resource: 'app-encuesta-encuestador',
      },
    ],
  },
  {
    title: 'Cultivos',
    icon: 'SunriseIcon',
    // tag: '1',
    tagVariant: 'light-warning',
    resource: 'app-cultivo-parcela',
    children: [
      {
        title: 'Parcela',
        route: 'app-cultivo-parcela',
        resource: 'app-cultivo-parcela',
      },
    ],
  },
  {
    title: 'Administración',
    icon: 'ServerIcon',
    // tag: '2',
    tagVariant: 'light-warning',
    resource: 'app-administracion-institucion',
    children: [
      {
        title: 'Institución',
        route: 'app-administracion-institucion',
        resource: 'app-administracion-institucion',
      },
      /* {
        title: 'Dependencia',
        route: 'app-administracion-proyecto',
        resource: 'app-administracion-proyecto',
      }, */
    ],
  },
  {
    title: 'Mantenimiento',
    icon: 'SettingsIcon',
    // tag: '1',
    tagVariant: 'light-warning',
    resource: 'app-mantenimiento-grupopcion',
    children: [
      {
        title: 'Grupo Opción',
        route: 'app-mantenimiento-grupopcion',
        resource: 'app-mantenimiento-grupopcion',
      },
      {
        title: 'Bloque',
        route: 'app-mantenimiento-bloque',
        resource: 'app-mantenimiento-bloque',
      },
      /* {
        title: 'Ubigeo',
        route: 'app-mantenimiento-ubigeo',
        resource: 'app-mantenimiento-ubigeo',
      }, */
    ],
  },
  {
    title: 'Seguridad',
    icon: 'UsersIcon',
    // tag: '1',
    tagVariant: 'light-warning',
    resource: 'apps-seguridad-usuario',
    children: [
      {
        title: 'Usuario',
        route: 'apps-seguridad-usuario',
        resource: 'apps-seguridad-usuario',
      },
      /* {
        title: 'Sistemas',
        route: 'apps-seguridad-sistema',
        resource: 'apps-seguridad-sistema',
      },
      {
        title: 'Permisos',
        route: 'apps-seguridad-permiso',
        resource: 'apps-seguridad-permiso',
      }, */
    ],
  },
]
